

















































































































































































































































































































































































import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import PieChart from "@/components/PieChart.vue";
import VAudio from "@/components/VAudio.vue";
import VCheckbox from "@/components/VCheckbox.vue";
import VIcon from "@/components/VIcon.vue";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import SpotMixin from "@/mixins/http/Spot";
import { AdcontrolProfile, Media, TimeInterval, User } from "@/models";
import ClientUserInfo from "@/models/Agents/UserInfo";
import WithTimeIntervals from "@/models/interfaces/WithTimeIntervals";
import Spot from "@/models/Spot";
import { ProfileCapabilitiesService } from "@/services/Profile/CapabilitiesService";
import { copyToClipboard } from "@/utils/copyToClipboard";
import { showToast } from "@/utils/ToastInvoker";
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import TimeDistribution from "../TimeDistribution.vue";
import VModalVideo from "../VModalVideo.vue";
import VVideoButton from "../VVideoButton.vue";

export interface SpotFilter {
  dateRange: Array<string | Date>;
  product?: string[] | string;
  media: string | string[];
  grpTarget?: string;
  vod?: boolean;
}

interface ChartAccumulator {
  key: string;
  count: number;
  data: number[];
  grpTarget?: string;
}

@Component({
  components: {
    PieChart,
    VIcon,
    VAudio,
    VCheckbox,
    VModalVideo,
    VVideoButton,
    TimeDistribution,
    MultiLevelSelect,
  },
})
export default class SpotList extends Mixins(SpotMixin) {
  @Prop({ required: true }) readonly filter!: SpotFilter;
  @Prop({ default: false }) readonly showGraphs!: boolean;
  @Ref() readonly videoModal!: VModalVideo;
  @Prop({ default: false }) readonly selectMode!: boolean;
  @Prop({ default: "" }) readonly search!: string;
  @Prop({ default: false }) readonly spotTypeDetail!: boolean;
  @Prop({ default: "duration" }) readonly unitOfMeasure!: string;
  @Prop({ default: null }) readonly adcontrolProfile!: AdcontrolProfile | null;

  @Getter("user") readonly user!: User;
  @Getter("profile") readonly profile!: AdcontrolProfile;
  @Getter("agentUserInfos") readonly agentUserInfo?: ClientUserInfo;

  selectAll = false;
  readonly mediaLabels = [null, "RADIO", "TV"];

  private currentVideoSources: string[] | null = null;

  spots: Array<Spot & WithTimeIntervals> = [];
  vodSpots: Array<Spot & WithTimeIntervals> = [];
  selected: string[] = [];
  loading = false;

  currentSort = "name";
  currentSortAsc = -1;
  unitOfMeasureValue = "";

  get hideNonVodIfProfileVodOnly(): boolean {
    if (this.profile?.mediaSourceKind == "msk_vod") {
      return true;
    }
    return false;
  }

  get filtered() {
    return this.spots.filter((o) =>
      o.name.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  get vodFiltered() {
    return this.vodSpots.filter((o) =>
      o.name.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  get sorted() {
    return this.filtered.sort(this.sortFunction());
  }

  private sortFunction() {
    return (a: Spot, b: Spot) => {
      if (this.currentSort == "duration") {
        if (a.duration.seconds > b.duration.seconds) {
          return this.currentSortAsc;
        } else {
          return -1 * this.currentSortAsc;
        }
      }

      if (this.currentSort == "percentage") {
        if (
          (a.intervalDetectionsCount / this.total) * 100 >
          (b.intervalDetectionsCount / this.total) * 100
        ) {
          return this.currentSortAsc;
        } else {
          return -1 * this.currentSortAsc;
        }
      }

      if (this.currentSort == "name") {
        if (a.name > b.name) {
          return this.currentSortAsc;
        } else {
          return -1 * this.currentSortAsc;
        }
      }

      if (this.currentSort == "grpCount") {
        if (a.grpCount > b.grpCount) {
          return this.currentSortAsc;
        } else {
          return -1 * this.currentSortAsc;
        }
      }

      if (this.currentSort == "grpOverSpot") {
        if (
          a.grpCount / a.intervalDetectionsCount >
          b.grpCount / b.intervalDetectionsCount
        ) {
          return this.currentSortAsc;
        } else {
          return -1 * this.currentSortAsc;
        }
      }

      if (this.currentSort == "intervalDetectionsCount") {
        if (a.intervalDetectionsCount > b.intervalDetectionsCount) {
          return this.currentSortAsc;
        } else {
          return -1 * this.currentSortAsc;
        }
      }

      if (this.currentSort == "spotType") {
        if ((a.spotType ?? "") > (b.spotType ?? "")) {
          return this.currentSortAsc;
        } else {
          return -1 * this.currentSortAsc;
        }
      }

      return this.currentSortAsc;
    };
  }

  protected shouldShowAChart(data: object[]) {
    return data.length > 0;
  }

  get shouldShowLeftChart(): boolean {
    return (
      (this.shouldShowAChart(this.leftChartData) ||
        !this.shouldShowRightChart) &&
      !this.onlyVod
    );
  }

  get shouldShowRightChart(): boolean {
    return this.shouldShowAChart(this.rightChartData);
  }

  get shouldShowBothCharts() {
    return this.shouldShowLeftChart && this.shouldShowRightChart;
  }

  get shouldShowVodChart() {
    return this.shouldShowAChart(this.vodChartData);
  }

  get showVod() {
    return this.spots.some((s) => s.hasVod);
  }

  get onlyVod() {
    return this.spots.every((s) => s.intervalDetectionsCount == 0);
  }

  get showEbiquity() {
    return this.filter.media == "1" && this.user.hasEbiquity;
  }

  get applyAgentsFilter(): boolean {
    return (
      ProfileCapabilitiesService.agentsModuleEnabled(
        this.user.profile,
        this.agentUserInfo
      ) && !(this.agentUserInfo?.superUser ?? false)
    );
  }

  isTv(media: string | number) {
    return media == 2;
  }

  onSelectAll(value: any) {
    this.selected = value.target.checked ? this.filtered.map((o) => o.id) : [];
    this.$emit("selected", this.selected);
  }

  onItemClicked(spot: Spot) {
    if (!this.selectMode) {
      this.$emit("clicked", spot);
    }
  }

  isSelected(id: string) {
    return this.selected.includes(id);
  }

  @Watch("selected")
  onSelected(selected: string[]) {
    this.$emit(
      "selected",
      this.filtered.filter((o) => selected.includes(o.id))
    );
  }

  @Watch("selectMode")
  onSelectedModeChanges() {
    this.selected = [];
  }

  onUnitOfMeasureChanged(unitOfMeasure: string) {
    this.unitOfMeasureValue = unitOfMeasure;
    if (unitOfMeasure !== "duration") {
      this.$emit("settings-changed", { unitOfMeasure });
    }
  }

  get granularity() {
    const [from, to] = this.filter.dateRange;
    if (!from || !to) {
      return "day";
    }
    const days = this.$moment(to).diff(from, "days");
    if (days <= 7) {
      return "day";
    } else if (days <= 31) {
      return "sweek";
    } else if (days <= 365) {
      return "month";
    } else {
      return "semester";
    }
  }

  get granularityLabel() {
    switch (this.granularity) {
      case "day":
        return "giornaliero";
      case "sweek":
        return "settimanale";
      case "month":
        return "mensile";
      case "semester":
        return "semestre";
      default:
        return "giornaliero";
    }
  }

  get mediaGroupedSpots() {
    const reduced = this.filtered.reduce(
      (result: any, spot: Spot & WithTimeIntervals) => {
        if (!result[spot.media.id]) {
          result[spot.media.id] = [];
        }
        result[spot.media.id].push(spot);
        return result;
      },
      {} as { [key: string]: Spot[] }
    );

    reduced["1"] = reduced["1"]?.sort(this.sortFunction()) ?? [];
    reduced["2"] = reduced["2"]?.sort(this.sortFunction()) ?? [];

    if (reduced["1"].length == 0) {
      delete reduced["1"];
    }

    if (reduced["2"].length == 0) {
      delete reduced["2"];
    }

    return reduced;
  }

  get total() {
    return this.filtered.reduce(
      (count, spot) => count + spot.intervalDetectionsCount,
      0
    );
  }

  get hasGrp() {
    return parseInt(this.filter?.grpTarget as string) > 0 && !this.hasRadio;
  }

  get hasRadio() {
    return this.filter?.media.includes("1") || this.filter?.media == "1";
  }

  getColumnClass(column: string) {
    if (this.currentSort == column) {
      if (this.currentSortAsc > 0) {
        return "sortable sorted--desc";
      } else {
        return "sortable sorted--asc";
      }
    } else {
      return "sortable";
    }
  }

  async created() {
    await this.loadSpots();
    this.unitOfMeasureValue = this.unitOfMeasure;
  }

  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.loadSpots();
  }

  @Watch("unitOfMeasure")
  onUnitChanged() {
    if (this.unitOfMeasureValue !== this.unitOfMeasure) {
      this.unitOfMeasureValue = this.unitOfMeasure;
    }
  }

  async loadSpots() {
    this.loading = true;

    this.spots = this.spots.slice(0, 9) || [];
    this.vodSpots = this.vodSpots.slice(0, 9) || [];

    let spotsDistributionQuery: any = {
      filter: this.filter,
      granularity: this.granularity,
    };

    if (this.applyAgentsFilter) {
      spotsDistributionQuery = {
        ...spotsDistributionQuery,
        agent_module_view: true,
      };
    }

    this.spots = await this.getSpotsDistribution(
      spotsDistributionQuery,
      "spots"
    );

    // We need vod values to show vod distributions and charts, so
    // we make a second call to get vod values if the first one hasn't
    if (this.filter.vod !== true) {
      let vodSpotsDistributionQuery: any = {
        filter: { ...this.filter, vod: true },
        granularity: this.granularity,
      };

      if (this.applyAgentsFilter) {
        vodSpotsDistributionQuery = {
          ...vodSpotsDistributionQuery,
          agent_module_view: true,
        };
      }

      this.vodSpots = await this.getSpotsDistribution(
        vodSpotsDistributionQuery,
        "spots"
      );
    } else {
      this.vodSpots = [...this.spots];
    }

    this.notifyRecordFound(this.spots.length);
    this.loading = false;
  }

  playVideo(url: string) {
    this.currentVideoSources = [url];
    this.videoModal.show();
    (document.activeElement as HTMLButtonElement)?.blur();
  }

  onHideModal() {
    this.currentVideoSources = null;
  }

  get leftChartTitle() {
    return "TV";
  }

  get rightChartTitle() {
    return "RADIO";
  }

  protected getLabelsFromSpots(
    filterFun: (spot: Spot) => boolean,
    spots: (Spot & WithTimeIntervals)[]
  ): string[] {
    const labels = this.sortByDurationInSecords([...spots]).reduce(
      (acc: string[], spot) => {
        if (filterFun(spot)) {
          const label =
            `${spot.duration.seconds}"` +
            (this.spotTypeDetail ? ` - ${spot.spotType}` : "");
          if (acc.indexOf(label) < 0) {
            acc.push(label);
          }
        }
        return acc;
      },
      []
    );

    if (this.isGrpOverSpots) {
      labels.reverse();
    }
    return labels;
  }

  get leftLabels() {
    return this.getLabelsFromSpots((spot: Spot) => {
      return spot.media.isTV;
    }, this.filtered);
  }

  get rightLabels() {
    return this.getLabelsFromSpots((spot: Spot) => {
      return spot.media.isRadio;
    }, this.filtered);
  }

  get vodLabels() {
    return this.getLabelsFromSpots((spot: Spot) => {
      return true;
    }, this.filtered);
  }

  sortTable(column: string) {
    if (this.currentSort == column) {
      this.currentSortAsc *= -1;
    } else {
      this.currentSort = column;
    }
  }

  protected sortByDurationInSecords(
    data: (Spot & WithTimeIntervals)[]
  ): (Spot & WithTimeIntervals)[] {
    return data.sort((a, b) => {
      if (a.duration.seconds < b.duration.seconds) {
        return -1;
      } else if (a.duration.seconds > b.duration.seconds) {
        return 1;
      } else if (this.spotTypeDetail) {
        if ((a.spotType ?? "") > (b.spotType ?? "")) {
          return -1;
        } else if ((a.spotType ?? "") < (b.spotType ?? "")) {
          return 1;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    });
  }

  protected sortBySpotType(
    data: (Spot & WithTimeIntervals)[]
  ): (Spot & WithTimeIntervals)[] {
    return data.sort((a, b) => {
      const aVal = a.spotType ?? "";
      const bVal = b.spotType ?? "";
      if (aVal < bVal) {
        return -1;
      } else if (aVal > bVal) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  getDistributionColumns(spot: Spot & WithTimeIntervals): number[] {
    return this.adcontrolProfile?.mediaSourceKind === "msk_vod"
      ? this.getVodDistributionColumns(spot)
      : this.getTimeDistributionColumns(spot);
  }

  getVodDistributionColumns(spot: Spot & WithTimeIntervals): number[] {
    const vodSpot = this.vodFiltered.find((e) => e.id === spot.id);
    return (
      vodSpot?.timeIntervals.map(
        (timeInt: TimeInterval) => timeInt.vodDetection || 0
      ) ?? []
    );
  }

  getTimeDistributionColumns(spot: Spot & WithTimeIntervals): number[] {
    const hasAuditel = this.user.profile?.hasFeature("auditel");
    const hasOnlyTv =
      this.filter.media.includes(Media.tv) &&
      !this.filter.media.includes(Media.radio);

    if (hasAuditel && hasOnlyTv) {
      return spot.timeIntervals.map((e) => +(e.grpCount || 0));
    }

    return spot.timeIntervals.map((e) => e.detectionsCount);
  }

  protected convertDataToNumberArray(
    data: (Spot & WithTimeIntervals)[],
    unitOfMeasure?: string
  ): number[] {
    const accumulator: ChartAccumulator = {
      key: "",
      count: 0,
      data: [],
    };

    const reduced = data.reduce(
      (acc: ChartAccumulator, spot: Spot & WithTimeIntervals) => {
        const value = this.extractValue(spot, unitOfMeasure);
        const key =
          spot.duration.id + (this.spotTypeDetail ? spot.spotType ?? "" : "");
        const lastKey = acc.key;
        if (key !== lastKey) {
          if (lastKey) {
            if (this.isGrpOverSpots) {
              const spots = data
                .filter(
                  (e) =>
                    e.duration.id +
                      (this.spotTypeDetail ? e.spotType ?? "" : "") ===
                    lastKey
                )
                .reduce((a, b) => a + b.intervalDetectionsCount, 0);
              acc.count /= spots;
            }
            acc.data.push(Math.round(acc.count * 100) / 100);
          }
          acc.key = key;
          acc.count = value;
        } else {
          acc.count += value;
        }
        return acc;
      },
      accumulator
    );

    if (reduced.count > 0) {
      if (this.isGrpOverSpots) {
        const spots = data
          .filter(
            (e) =>
              e.duration.id + (this.spotTypeDetail ? e.spotType ?? "" : "") ===
              reduced.key
          )
          .reduce((a, b) => a + b.intervalDetectionsCount, 0);
        reduced.count /= spots;
      }
      reduced.data.push(reduced.count);
    }
    return reduced.data;
  }

  private extractValue(spot: Spot & WithTimeIntervals, unitOfMeasure?: string) {
    switch (unitOfMeasure ?? this.unitOfMeasureValue) {
      case "duration":
        return 1;
      case "spots":
        return spot.intervalDetectionsCount;
      case "seconds":
        return spot.duration.seconds * spot.intervalDetectionsCount;
      case "grp":
      case "grp_over_spots":
        return spot.grpCount;
      case "ebiquity_min":
        return spot.timeIntervals.reduce(
          (acc, e) => acc + (e.ebiquityMin ?? 0),
          0
        );
      case "ebiquity_max":
        return spot.timeIntervals.reduce(
          (acc, e) => acc + (e.ebiquityMax ?? 0),
          0
        );
      case "audience":
        return spot.timeIntervals.reduce(
          (acc, e) => acc + (e.audienceCount ?? 0),
          0
        );
      case "vod":
        return spot.timeIntervals.reduce(
          (acc, e: TimeInterval) => acc + (e.vodDetection ?? 0),
          0
        );
    }
    return 0;
  }

  protected convertSpotTypeDataToNumberArray(
    data: (Spot & WithTimeIntervals)[]
  ): number[] {
    const accumulator = {
      spotType: "",
      count: 0,
      data: [] as number[],
    };

    const reduced = data.reduce((acc, spot: Spot & WithTimeIntervals) => {
      if (spot.spotType != acc.spotType) {
        if (acc.spotType !== "") {
          acc.data.push(acc.count);
        }
        acc.spotType = spot.spotType ?? "";
        acc.count = 1;
      } else {
        acc.count++;
      }
      return acc;
    }, accumulator);

    if (reduced.count > 0) {
      reduced.data.push(reduced.count);
    }
    return reduced.data;
  }

  protected convertNumericDataToChartData(labels: string[], data: number[]) {
    if (this.isGrpOverSpots) {
      return labels
        .map((label, idx) => {
          return {
            label,
            data: [
              ...new Array<number>(idx).fill(0),
              data[idx] ?? 0,
              ...new Array<number>(labels.length - idx - 1).fill(0),
            ],
          };
        })
        .filter((e) => e.data.reduce((acc, v) => acc + v, 0));
    }
    return data.map((data, idx) => {
      return {
        label: labels[idx],
        data: [data],
      };
    });
  }

  protected genChartData(
    filterFun: (spot: Spot) => boolean,
    labels: string[],
    unitOfMeasure?: string
  ): { label: string; data: number[] }[] {
    const data =
      unitOfMeasure == "vod"
        ? this.vodFiltered.filter((spot) => filterFun(spot))
        : this.filtered.filter((spot) => filterFun(spot));
    const sortedData = this.sortByDurationInSecords(data);
    if (this.isGrpOverSpots) {
      sortedData.reverse();
    }
    const numericData = this.convertDataToNumberArray(
      sortedData,
      unitOfMeasure
    );
    return this.convertNumericDataToChartData(labels, numericData);
  }

  protected genSpotTypeChartData(
    filterFun: (spot: Spot) => boolean
  ): { label: string; data: number[] }[] {
    const data = this.filtered.filter((spot) => filterFun(spot));
    const sortedData = this.sortBySpotType(data);
    const numericData = this.convertSpotTypeDataToNumberArray(sortedData);
    return this.convertNumericDataToChartData(
      ["Tabellare", "Sponsorizzazioni"],
      numericData
    );
  }

  get vodChartData() {
    return this.genChartData(
      (spot: Spot) => {
        return spot.hasVod;
      },
      this.vodLabels,
      "vod"
    );
  }

  get leftChartData() {
    return this.genChartData((spot: Spot) => {
      return spot.media.isTV;
    }, this.leftLabels);
  }

  get rightChartData() {
    return this.genChartData((spot: Spot) => {
      return spot.media.isRadio;
    }, this.rightLabels);
  }

  get leftSpotTypeChartData() {
    return this.genSpotTypeChartData((spot: Spot) => {
      return spot.media.isTV;
    });
  }

  get rightSpotTypeChartData() {
    return this.genSpotTypeChartData((spot: Spot) => {
      return spot.media.isRadio;
    });
  }

  protected notifyRecordFound(record: number) {
    this.$emit("found", record);
  }

  public async copySpotUrlToClipboard(url: string) {
    await copyToClipboard(url);
    showToast("URL copiato", { position: "bottom-right" });
  }

  get isGrpOverSpots() {
    return this.unitOfMeasureValue === "grp_over_spots";
  }

  get distributionHeaderClass() {
    if (this.shouldShowBothCharts) {
      return "col-md-12";
    }
    return "col-md-6";
  }

  get spotTypeHeaderClass() {
    if (this.shouldShowBothCharts) {
      return "col-md-12 order-1";
    }
    return "col-md-6";
  }

  reduceAttributeInTimeInterval(spotGroup: any, attribute: string) {
    return spotGroup.reduce(
      (a: number, b: Spot) =>
        a +
        b?.timeIntervals?.reduce(
          (a, b: TimeInterval) => a + ((b as any)[attribute] || 0),
          0
        ),
      0
    );
  }

  get unitOfMeasureOptions(): Array<MultiLevelObject> {
    const unitOptions: Array<MultiLevelObject> = [];

    if (this.showEbiquity) {
      unitOptions.push(
        {
          id: "ebiquity_min",
          text: "€ (Stima Min.)",
        },
        {
          id: "ebiquity_max",
          text: "€ (Stima Max.)",
        }
      );
    }

    if (!this.filter.media.includes(Media.radio)) {
      unitOptions.push(
        {
          id: "grp",
          text: "GRP",
        },
        {
          id: "grp_over_spots",
          text: "GRP / Spot",
        },
        {
          id: "audience",
          text: "Contatti",
        }
      );
    }
    return [
      {
        id: "duration",
        text: "Durata",
      },
      {
        id: "spots",
        text: "Spot",
      },
      {
        id: "seconds",
        text: "Secondi",
      },
      ...unitOptions,
    ];
  }
}
